import { useLocation } from "react-router-dom";

export function useDesk() {
  const { pathname } = useLocation();
  const variant = pathname.startsWith("/broker")
    ? "broker"
    : pathname.startsWith("/admin")
      ? "admin"
      : "agent";
  const base = variant === "broker" ? "/broker" : variant === "admin" ? "/admin" : "/agent";
  const dashboard = variant === "admin" ? "/admin" : `${base}/dashboard`;
  return {
    variant,
    base,
    dashboard,
    clients: `${base}/clients`,
    responses: `${base}/responses`,
    messages: `${base}/messages`,
    officeMessages: `${base}/office`,
    officeArchive: `${base}/office/archive`,
    calendar: `${base}/calendar`,
    settings: "/account?tab=privacy",
    profile: "/account",
    archive: `${base}/messages/archive`,
    audit: variant === "broker" ? "/broker/audit" : "/agent/clients",
    files: `${base}/files`,
    file: (id) => `${base}/files/${encodeURIComponent(id)}`,
    documents: `${base}/documents`,
    reports: variant === "admin" ? `${dashboard}#sample-reports` : `${base}/documents#desk-reports`,
    suggestions: `${base}/suggestions`,
    users: `${base}/users`,
    accounts: variant === "admin" ? "/admin/accounts" : "",
    controls: `${base}/controls`,
    sitemap: `${base}/sitemap`,
    startHere: `${base}/start-here`,
    registerClient: "/client/register",
    hub: `${base}/hub`,
    founders: variant === "admin" ? "/admin/founders" : "",
    prospects: `${base}/prospects`,
    client: (id) => `${base}/client/${id}`,
    responseNew: `${base}/responses/new`,
    responsePath: (id, step) => `${base}/responses/${id}/${step}`,
  };
}
